import React, { useEffect, useState } from 'react';
import './LessonVideo.scss';
import VideoPlayer from '../../../../components/VideoPlayer/VideoPlayer';
import Skeleton from '../../../../components/Skeleton/Skeleton';

export default function LessonVideo({ selectedTrainingLesson, lessonMediaUrl }) {
    const [hasStarted, setHasStarted] = useState(false);
    // Ajout d'une clé unique basée sur l'URL de la vidéo
    const [videoKey, setVideoKey] = useState(0);

    // Réinitialiser l'état quand la leçon change
    useEffect(() => {
        setHasStarted(false);
        setVideoKey(prevKey => prevKey + 1);
    }, [selectedTrainingLesson?.id]);

    return (
        <>
            {
                selectedTrainingLesson ?
                    selectedTrainingLesson.video && 
                        <div className='training-lesson-video'>
                            <VideoPlayer
                                key={videoKey}
                                src={lessonMediaUrl(selectedTrainingLesson.video)}
                                autoPlay={false}
                                controls={true}
                                loop={false}
                                muted={false}
                                width="100%"
                                height="auto"
                                className="rounded-lg"
                                hasStarted={hasStarted}
                                setHasStarted={setHasStarted}
                            />
                        </div>
                :
                <Skeleton
                    width='100%'
                    aspectRatio='16/9'
                    borderRadius='1rem'
                    bkgColor='#EEE6DB'
                    animColor='#F5F0ED'
                />
            }
        </>
    )
}